var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrideAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8002 16C28.8002 23.0688 23.0687 28.8 16.0002 28.8C8.93044 28.8 3.2002 23.0691 3.2002 16C3.2002 8.93089 8.93076 3.20001 16.0002 3.20001C23.0687 3.20001 28.8002 8.93089 28.8002 16Z",
    fill: "#E8E8ED",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 5.46017C12.4657 5.46017 9.59975 8.32481 9.59975 11.8599L9.60007 20.1703C9.60007 22.0928 8.86663 24.0141 7.40039 25.4797C9.67303 27.5424 12.6897 28.8 16.0001 28.8C19.3105 28.8 22.3271 27.5424 24.5998 25.4797C23.1338 24.0141 22.3998 22.0928 22.3998 20.1703L22.4004 11.8595C22.4004 8.32449 19.5348 5.46017 15.9998 5.46017Z",
    fill: "white",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7901 23.0761C17.2486 24.6163 14.7488 24.6163 13.208 23.0761C13.4435 22.9785 13.655 22.8364 13.8326 22.6588C14.1811 22.3113 14.3962 21.8288 14.3962 21.2979V20.8313C14.8941 21.1315 15.4336 21.2988 15.999 21.2988C16.5651 21.2988 17.1053 21.1318 17.6026 20.8313V21.2979C17.6026 21.8288 17.8182 22.3113 18.167 22.6588C18.3427 22.8364 18.5555 22.9788 18.7901 23.0761Z",
    fill: "#FCD3C9",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6026 20.8317C17.1053 21.1319 16.5652 21.2992 15.9991 21.2992C15.4336 21.2992 14.8941 21.1322 14.3962 20.8317V21.2983C14.3962 21.5421 14.3488 21.7741 14.2666 21.9892C14.8119 22.2724 15.3933 22.4279 15.9991 22.4279C16.6055 22.4279 17.1879 22.2724 17.7325 21.9892C17.6496 21.7741 17.6026 21.5421 17.6026 21.2983V20.8317Z",
    fill: "#EAC5BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7901 23.0761C17.2486 24.6163 14.7488 24.6163 13.208 23.0761C13.4435 22.9785 13.655 22.8364 13.8326 22.6588C14.1811 22.3113 14.3962 21.8288 14.3962 21.2979V20.8313C14.8941 21.1315 15.4336 21.2988 15.999 21.2988C16.5651 21.2988 17.1053 21.1318 17.6026 20.8313V21.2979C17.6026 21.8288 17.8182 22.3113 18.167 22.6588C18.3427 22.8364 18.5555 22.9788 18.7901 23.0761Z",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 20.1702L22.4007 11.8595C22.4007 8.32448 19.5351 5.45984 16 5.45984C15.8096 5.45984 15.6215 5.46976 15.4355 5.48608C18.7063 5.77184 21.272 8.51456 21.272 11.8595L21.2714 14.3939C21.385 14.6035 21.4515 14.8422 21.4515 15.0986C21.4515 15.503 21.3863 15.8832 21.2714 16.2147V20.1702C21.2714 21.7882 21.7927 23.4038 22.8314 24.7491L24.5984 25.4813C24.5991 25.4806 24.5997 25.48 24.6 25.4797C23.1341 24.0141 22.4 22.0928 22.4 20.1702Z",
    fill: "#EDEDEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4528 13.6937C17.9939 13.6937 16 11.6998 16 9.24094V8.4707C18.4592 8.4707 20.4528 10.4637 20.4528 12.9238V13.6937Z",
    fill: "#FAD05A",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5479 13.6928C14.0061 13.6928 15.9997 11.6995 15.9997 9.24062V8.4707C13.5408 8.47102 11.5479 10.4637 11.5479 12.9238V13.6928Z",
    fill: "#FAD05A",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4525 13.6928C21.0326 13.8992 21.4506 14.447 21.4506 15.0985C21.4506 16.375 20.8035 17.4083 19.9971 17.4448C19.2544 19.7315 17.7443 21.2992 15.9987 21.2992C14.2538 21.2992 12.7443 19.7315 12.0013 17.4438C11.1949 17.4077 10.5479 16.375 10.5479 15.0985C10.5479 14.447 10.9661 13.8992 11.5469 13.6928C14.0058 13.6928 15.9994 11.6995 15.9994 9.24062L15.9997 8.4707V9.24094C15.9997 11.6998 17.9936 13.6937 20.4525 13.6928Z",
    fill: "#FCD3C9",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40039 25.4813C8.96071 26.8963 10.873 27.9299 12.9886 28.4407C13.9556 28.6739 14.963 28.8 16.0004 28.8C17.0385 28.8 18.0455 28.6739 19.0113 28.4407C21.1265 27.9299 23.0388 26.897 24.5998 25.4813L18.7908 23.0762C17.2494 24.6163 14.7495 24.6163 13.2087 23.0762L7.40039 25.4813Z",
    fill: "white",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.27 26.7107C19.8153 25.2541 17.4549 25.2541 15.9996 26.7107C14.5449 25.2541 12.1845 25.2541 10.7295 26.7107C12.1845 25.2541 14.5449 25.2541 15.9996 26.7107C17.4549 25.2541 19.8153 25.2541 21.27 26.7107Z",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 5.46017C12.4657 5.46017 9.59975 8.32481 9.59975 11.8599L9.60007 20.1703C9.60007 22.0928 8.86663 24.0141 7.40039 25.4797C9.67303 27.5424 12.6897 28.8 16.0001 28.8C19.3105 28.8 22.3271 27.5424 24.5998 25.4797C23.1338 24.0141 22.3998 22.0928 22.3998 20.1703L22.4004 11.8595C22.4004 8.32449 19.5348 5.46017 15.9998 5.46017Z",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5187 13.5834C12.2055 13.6528 11.881 13.6928 11.5469 13.6928C10.9661 13.8992 10.5479 14.4471 10.5479 15.0986C10.5479 16.3751 11.1952 17.4074 12.0013 17.4439C12.744 19.7312 14.2538 21.2992 15.9987 21.2992C16.247 21.2992 16.4893 21.264 16.7258 21.2032C14.3664 20.6215 12.5565 17.441 12.5187 13.5834Z",
    fill: "#EAC5BD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4525 13.6928C21.0326 13.8992 21.4506 14.447 21.4506 15.0985C21.4506 16.375 20.8035 17.4083 19.9971 17.4448C19.2544 19.7315 17.7443 21.2992 15.9987 21.2992C14.2538 21.2992 12.7443 19.7315 12.0013 17.4438C11.1949 17.4077 10.5479 16.375 10.5479 15.0985C10.5479 14.447 10.9661 13.8992 11.5469 13.6928C14.0058 13.6928 15.9994 11.6995 15.9994 9.24062L15.9997 8.4707V9.24094C15.9997 11.6998 17.9936 13.6937 20.4525 13.6928Z",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.4707V8.62078C17.9114 9.12126 19.3235 10.855 19.3235 12.9238V13.5437C19.6851 13.6384 20.0621 13.6937 20.4525 13.6937V12.9238C20.4528 10.4637 18.4595 8.4707 16 8.4707Z",
    fill: "#E2BD53"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4528 13.6937C17.9939 13.6937 16 11.6998 16 9.24094V8.4707C18.4592 8.4707 20.4528 10.4637 20.4528 12.9238V13.6937Z",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 8.35979C16.5528 8.35979 17.0802 8.46156 17.5729 8.64C17.5885 8.54834 17.6004 8.45633 17.6004 8.36014C17.6004 7.45468 16.8846 6.72 16.0006 6.72C15.1168 6.72 14.4004 7.45433 14.4004 8.36014C14.4004 8.45633 14.4126 8.54834 14.4279 8.64C14.9206 8.46156 15.4484 8.35979 16.0006 8.35979Z",
    fill: "#FAD05A",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 7.71774C15.505 7.71774 15.0321 7.80446 14.5873 7.95422C14.5281 8.11582 14.4941 8.28926 14.4941 8.47134C14.4941 8.55966 14.5057 8.64414 14.5201 8.7283C14.9837 8.56446 15.4801 8.47102 16.0001 8.47102C16.5197 8.47102 17.0161 8.56446 17.4797 8.7283C17.4945 8.64414 17.5057 8.55966 17.5057 8.47134C17.5057 8.28926 17.4717 8.11582 17.4125 7.95422C16.9677 7.80446 16.4948 7.71774 16.0001 7.71774Z",
    fill: "#E2BD53"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 8.35979C16.5528 8.35979 17.0802 8.46156 17.5729 8.64C17.5885 8.54834 17.6004 8.45633 17.6004 8.36014C17.6004 7.45468 16.8846 6.72 16.0006 6.72C15.1168 6.72 14.4004 7.45433 14.4004 8.36014C14.4004 8.45633 14.4126 8.54834 14.4279 8.64C14.9206 8.46156 15.4484 8.35979 16.0006 8.35979Z",
    stroke: "#414042",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrideAvatar);
export default __webpack_public_path__ + "static/media/bride-avatar.9a00985e.svg";
export { ForwardRef as ReactComponent };